"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * User role.
 *
 * @author Radek Beran
 */


var Role =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Role, _DomainObject_1$Domai);

  function Role(name) {
    var _this;

    _classCallCheck(this, Role);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Role).call(this));
    _this.name = name;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(Role, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof Role) {
        return this.name === other.name;
      } else {
        return false;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.name);
    }
  }]);

  return Role;
}(DomainObject_1.DomainObject);

exports.Role = Role;

Role.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Role.name);
  return {
    name: builder.str('name')
  };
}();